import { Decision } from "components/Decision";
import { GlobalContext } from "contexts/GlobalContext";
import { Page } from "pages/Page";
import { useContext } from "react";

// error strings that are meaningful to show the user verbatim; anything else
// falls back to a generic message, so internal errors aren't surfaced
const userFacingErrors = new Set(["Could not find game"]);

export const ErrorPage = () => {
    const { error } = useContext(GlobalContext);

    const text = error && userFacingErrors.has(error) ? error : "An unexpected error occurred";

    return (
        <Page canonical={window.location.href} description="Server error" title="Server error">
            <div>
                <Decision
                    text={text}
                    description="If the problem persists try closing all your browser windows"
                    showReloadButton={true}
                />
            </div>
        </Page>
    );
};
